import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { navigateTo } from 'Helpers/Redirect';
import { changePasswordPath } from 'Consts/Strings';
import { withStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import TextButton from 'Components/ComponentLibrary/Components/Uncategorized/TextButton';

const styles = (theme) => ({
  root: {
    padding: theme.spacing(2),
  },
});

const ChangePasswordButton = ({
  classes,
  className,
  disabled,
}) => {
  return (
    <TextButton
      className={classNames(classes.root, className)}
      disabled={disabled}
      onClick={() => navigateTo(changePasswordPath)}
      test={'authentication-forgot-password-button'}
      fullWidth
    >
      {'Forgot password'}
    </TextButton>
  );
};

ChangePasswordButton.defaultProps = {
  className: '',
  disabled: false,
};

ChangePasswordButton.propTypes = {
  className: PropTypes.string,
  classes: PropTypes.object.isRequired,
  disabled: PropTypes.bool,
};

export default withStyles(styles)(ChangePasswordButton);
